'use client'

import { validate } from 'uuid'
import { graphql } from '~/gql'
import { useGQLQuery } from '~/hooks/useGraphQL'

// 10 Minutes
const staleTime = 10 * 60 * 1000

const userQuery = graphql(`
  query User($memberId: String!) {
    user(memberId: $memberId) {
      auth0Id
      profile {
        firstName
        lastName
        avatar
        email
        fullName
      }
    }
  }
`)

export const useUserQuery = (memberId: string) =>
  useGQLQuery(
    userQuery,
    { memberId },
    { staleTime, enabled: !!memberId && validate(memberId) }
  )
